import { ServerError } from "api/models/response/server-error";
import axios, { AxiosError, HttpStatusCode } from "axios";
import { convertAxiosErrorToValidationError } from "commons/ultilities/validation";
import { getRootStoreAccessor } from "mobx-stores/_root-store-accessor";
import { enqueueSnackbar } from "notistack";
import { authBusiness } from "../bussiness/auth/auth-business";

// make an 'instance' of it
const instance = axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT,
});

// Where you would set stuff like your 'Authorization' header, etc ...
instance.interceptors.request.use(
  async function (config) {
    // Do something before request is sent
    const accessToken = await authBusiness.getAccessToken();
    config.headers.Authorization = `Bearer ${accessToken}`;
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  },
);

// Add a response interceptor
instance.interceptors.response.use(
  function (response) {
    if (
      response.config.method === "post" ||
      response.config.method === "put" ||
      response.config.method === "delete"
    ) {
      if (response.status >= 200 && response.status < 300) {
        enqueueSnackbar("Thành công !", { variant: "success" });
      }
    }

    return response;
  },
  function (error: AxiosError) {
    if (error.status) {
      if (error.status === HttpStatusCode.Unauthorized) {
        return authBusiness.logout();
      }
      if (error.status >= 500 && error.status < 600) {
        enqueueSnackbar("Lỗi server!", { variant: "error" });
      }
      if (
        (error.config?.method === "post" || error.config?.method === "put") &&
        (error.status === HttpStatusCode.Forbidden ||
          error.status === HttpStatusCode.BadRequest)
      ) {
        const rootStore = getRootStoreAccessor();
        const dataErr = (error.response?.data as any)?.error as ServerError;
        let message = "Không xác định";
        if (dataErr.validationErrors && dataErr.validationErrors.length > 0) {
          message = dataErr.validationErrors[0]?.message;
        } else {
          const errorData = convertAxiosErrorToValidationError(error);
          message = errorData.message;
        }

        rootStore?.setValidationErrorVisible(true);
        rootStore?.setValidationErrorMessage(message);
      }
    } else {
      enqueueSnackbar("Không xác định!", { variant: "info" });
    }

    return Promise.reject(error);
  },
);

export const axiosInstance = instance;
